import { render } from "./SuccessScreen.vue?vue&type=template&id=47927149&scoped=true&ts=true"
import script from "./SuccessScreen.vue?vue&type=script&lang=ts"
export * from "./SuccessScreen.vue?vue&type=script&lang=ts"

import "./SuccessScreen.vue?vue&type=style&index=0&id=47927149&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47927149"]])

export default __exports__